import React from 'react';
import { startLogin } from '../lib/auth';
import { Button } from './ui/button';
import { LogIn, ShieldCheck, Sparkles } from 'lucide-react';
import './LoginScreen.css';

export const LoginScreen = () => {
  return (
    <div className="login-screen" data-testid="login-screen">
      <div className="login-bg">
        <div className="login-glow login-glow-1" />
        <div className="login-glow login-glow-2" />
        <div className="login-grid" />
      </div>

      <div className="login-card">
        <div className="login-brand">
          <img src="/company-logo.png" alt="IRI" className="login-logo" />
          <div>
            <div className="login-company">International Reporting Inc.</div>
            <div className="login-subtitle">Conference Display Control</div>
          </div>
        </div>

        <div className="login-content">
          <h1 className="login-title">Sign in to continue</h1>
          <p className="login-description">
            Access the live control panel to manage session screens, countdown
            timers, and presenter windows for your meetings.
          </p>

          <Button
            type="button"
            onClick={startLogin}
            className="login-btn"
            data-testid="google-signin-btn"
          >
            <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
              <path
                fill="#fff"
                d="M21.35 11.1H12v3.2h5.35c-.23 1.5-1.7 4.4-5.35 4.4-3.22 0-5.84-2.66-5.84-5.95s2.62-5.95 5.84-5.95c1.83 0 3.06.78 3.76 1.45l2.57-2.47C16.85 4.27 14.6 3.3 12 3.3 7.13 3.3 3.2 7.22 3.2 12.1s3.93 8.8 8.8 8.8c5.08 0 8.45-3.57 8.45-8.6 0-.58-.06-1.02-.1-1.2z"
              />
            </svg>
            <span>Continue with Google</span>
            <LogIn className="w-4 h-4 ml-auto opacity-70" />
          </Button>

          <div className="login-features">
            <div className="login-feature">
              <ShieldCheck className="w-4 h-4 text-teal-400" />
              <span>Secure Google sign-in</span>
            </div>
            <div className="login-feature">
              <Sparkles className="w-4 h-4 text-teal-400" />
              <span>Live presenter window for Zoom & Teams sharing</span>
            </div>
          </div>
        </div>

        <div className="login-footer">
          <p>Presenter view remains publicly viewable for attendees.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
